export const SET_ALL_INDI_PROGRAMS = 'SET_ALL_INDI_PROGRAMS';
export const SET_INDI_PROGRAMS = 'SET_INDI_PROGRAMS';
